import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Errors, actions, track } from 'react-redux-form'
import { Row, Col, Button, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Number from '../../common/form/spinner'
import { basketUpdateLineItem, deleteFromBasket, getOrderToConfirm } from '../../../actions/orders';
import no_image from '../../../assets/img/no_photo.png'
import redInfo from '../../../assets/img/i-Red@2x.png';
import gameNextLevel from '../../../assets/img/game_next_level.png';
import {getMinimumOrderQuantityAndNotify} from "../../../utils/minimum-order-quantity-toast";

class OrderDetailRow extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = (event) => {
    let qty = getMinimumOrderQuantityAndNotify(event.target.value, this.props.item.attributes.product["minimum-order-quantity"]);
    this.props.dispatch(basketUpdateLineItem({ id: this.props.item.id, product: { id: this.props.item.attributes.product.id } }, qty))
      .then(() => this.props.dispatch(getOrderToConfirm(true, this.props.selectedOutletId)));
  };

  handleDelete = () => {
    this.props.dispatch(actions.change(`.line_items_attributes[${this.props.index}]._destroy`, true));
    this.props.dispatch(deleteFromBasket({ id: this.props.item.id }))
      .then(() => this.props.dispatch(getOrderToConfirm(true, this.props.selectedOutletId)));
  };

  render() {
    const { item, errors, confirmedProduct, selectedOutletId, orderLimitCategoryIds, possibleHighlight, replacements,
      activeGameProductIds, activeGameProducts, currentGameLevel, nextGameLevel } = this.props;
    const { attributes } = item;
    const productData = attributes.product;
    const maxProduct = productData["max-per-order"];
    const img = productData.links.image || no_image;

    return (
      <Row>
        {(replacements.filter(e => e.replacement.id === productData['id']).length > 0) && (<Row className="red-replacement">
            <Col lg={12}>
              <Glyphicon glyph="retweet" /> Replacement product
            </Col>
          </Row>
        )}
        {maxProduct && attributes['product-qty'] === maxProduct ?
          (<Row className="red-replacement">
            <Col lg={12}>
              This item is limited to {maxProduct} per order
            </Col>
          </Row>) :
          ''
        }
        {
        activeGameProductIds && (activeGameProductIds.length == 0 || activeGameProductIds.includes(item.attributes.product.id)) &&
        nextGameLevel &&
         (<Row className="red-replacement">
            <Col lg={12}>
            <img src={gameNextLevel} alt="" height="32px"/>&nbsp;
            Increase your order to <b>{nextGameLevel['minimum_number_of_outers']}x outers&nbsp;
            {activeGameProducts.length > 1 ? "of " + activeGameProducts.join(', ') : ''}</b>
            &nbsp;to qualify for a game of prize <b>€{nextGameLevel['prize_amount']}!</b>&nbsp;
            {currentGameLevel ? "(current game win amount: €" + currentGameLevel['prize_amount'] + ")" : ''}
            </Col>
          </Row>
        )}
        <Row>
        </Row>
        <Row className={
          [
            "order-details-row",
            (possibleHighlight && orderLimitCategoryIds.includes(productData["category-id"])) ? "red-background" : '',
            replacements.filter(e => e.replacement.id === productData['id']).length > 0 ? 'has-replacement-product' : '',
            maxProduct && attributes['product-qty'] === maxProduct ? 'has-replacement-product' : ''
          ]
        }>
          <Col xs={8} md={2} className="image-container p-0">
            <img src={img} alt="No image" />
          </Col>
          <Col xs={12} md={7} className="col-spacer p-0">
            <Row className="name-container">
              <span className="order-item-name">{productData.name}</span>
            </Row>
            <Row className="row-spacer">
              <Col xs={6} className="price-column">
                <div className="promotional-price"><span>Outer Price €{productData['outer-price'].toFixed(2)}</span></div>
              </Col>
              <Col xs={6} className="quantity-column">
                <p className="quantity">Quantity</p>
                <div className="ch-border">
                  <Number
                    min={1}
                    max={999}
                    model={track('deep.order.confirm.line_items_attributes[].product_qty', { id: item.id })}
                    value={+attributes['product-qty']}
                    onChange={this.handleChange} />
                </div>
              </Col>
            </Row>
            {
              confirmedProduct && confirmedProduct.error && confirmedProduct.id === item.id &&
              <div className="errors">
                <span>{confirmedProduct.error}</span>
              </div>
            }
            {
              errors && errors[item.id] &&
              <div className="errors">
                <span>{errors[item.id]}</span>
              </div>
            }
          </Col>
          <Col xs={8} md={3} className="text-right p-0">
            <div className="delete-order mb-5">
              <Button onClick={this.handleDelete}><Glyphicon glyph="trash" /></Button>
            </div>
            <div className="price-column">
              {attributes['promotion-is-available'] && (
                <strong className="promotional-price">
                  {!selectedOutletId && (
                    <OverlayTrigger
                      placement="left"
                      overlay={<Tooltip id="tooltip" className="tooltip">
                        Please select a delivery address to check if your store is
                        eligible for this promotional price
                      </Tooltip>}>
                      <img src={redInfo} alt="" />
                    </OverlayTrigger>
                  )}
                  €{attributes['total-with-current-promotion'].toFixed(2)}
                </strong>
              )}
              <strong className={attributes['promotion-is-available'] ? 'original-price' : ''}>Total €{attributes['line-total'].toFixed(2)}</strong>
            </div>
            <Errors
              show={{ touched: true, focus: false }}
              className="errors"
              model={track('.line_items_attributes[].product_qty', { id: item.id })} />
            <Control type="hidden" model={`deep.order.confirm.line_items_attributes[${this.props.index}].id`} value={item.id} />
          </Col>
        </Row>
      </Row>
    )
  }
}

export default connect()(OrderDetailRow)



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/order-details-row.jsx